import React from 'react';
import { Wifi, WifiOff } from 'lucide-react';

export interface StatusIndicatorStyle01Props {
  online: boolean;
  label?: string;
  showIcon?: boolean;
}

/**
 * StatusIndicator Style 01 - Badge
 * Colored badge showing online/offline status
 */
export const Style01_Badge: React.FC<StatusIndicatorStyle01Props> = ({
  online,
  label,
  showIcon = true
}) => {
  return (
    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
      online 
        ? 'bg-green-500/20 text-green-400' 
        : 'bg-red-500/20 text-red-400'
    }`}>
      {showIcon && (
        online 
          ? <Wifi className="w-3 h-3" /> 
          : <WifiOff className="w-3 h-3" />
      )}
      <span>{label || (online ? '在線' : '離線')}</span>
    </div>
  );
};

export default Style01_Badge;
